import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Consumption } from '../Models/Consumption';
import { ConsumptionPeriod } from '../Models/ConsumptionPeriod';
import { UntypedFormArray, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageConsumptionService } from './../ph-bhp-feature-package-consumption.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-view-quarter-consumption',
  templateUrl: './ph-bhp-view-quarter-consumption.component.html',
  styleUrls: ['./ph-bhp-view-quarter-consumption.component.css']
})
export class PhBhpViewQuarterConsumptionComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isMilliliter = true;
  isLiter = true;
  viewFlag: string = 'liter';
  consumptionJsonData;
  consumptionID: number;
  consumptionData: Array<Consumption> = [];
  consumptionPeriodData: Array<ConsumptionPeriod> = [];
  consumptionQuarterPeriodForm: UntypedFormGroup;
  items: UntypedFormArray;
  periodNumber: number;
  haiOccurrences: number;
  haiEnabled: boolean = false;
  consumptionPeriodID: number;
  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  consumptionConfigDetail: Array<any> = [];
  viewConsumption: boolean = false;
  editconsumptionDisabled: boolean = false;
  @Output() childData = new EventEmitter();
  translationKeys: typeof TranslationKeys = TranslationKeys;
  consumptionYearConfiguration: any;

  constructor(private service: PHBHPFeaturePackageConsumptionService, private fb: UntypedFormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    this.consumptionID = parseInt(this.activatedRoute.snapshot.paramMap.get('Id'));
    if (this.layoutService.institutionID) {
      this.getConsumptionConfigByInstitutionIdList();
      this.getConsumptionPeriodLis();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.layoutService.institutionID = Id
      this.getConsumptionConfigByInstitutionIdList();
      this.getConsumptionPeriodLis();
      this.router.navigate(['/consumption/new']);
    });
    this.periodNumber = 1;
    this.consumptionQuarterPeriodForm = this.fb.group({
      items: this.fb.array([this.createItem()])
    });
    for (let i = 0; i < 3; i++) {
      this.periodNumber = i + 2;
      this.items = this.consumptionQuarterPeriodForm.get('items') as UntypedFormArray;
      this.items.push(this.createItem());
    }
  }
  EditConsumption() {
    this.viewConsumption = true;
    this.editconsumptionDisabled = true;
    this.consumptionQuarterPeriodForm.enable();
    this.childData.emit({ key: true })
  }

  updateConsumptionPeriod(value) {
    this.convertCommaToDot();
    var formValue1: Boolean = false;
    var consumptionValueFlag: Boolean = false;
    var patientDaysFlag: Boolean = false;
    for (let i = 0; i < this.consumptionQuarterPeriodForm.value.items.length; i++) {
      if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue == null) {
        this.consumptionQuarterPeriodForm.value.items[i].consumptionValue = "";
      }
      if (this.consumptionQuarterPeriodForm.value.items[i].patientDays == null || this.consumptionQuarterPeriodForm.value.items[i].patientDays == 0) {
        this.consumptionQuarterPeriodForm.value.items[i].patientDays = "";
      }
      if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue != "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays == "") {
        patientDaysFlag = true;
        break;
      } else if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue == "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays != "") {
        consumptionValueFlag = true;
        break;
      } else if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue != "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays != "") {
        formValue1 = true;
      }
    }

    if (patientDaysFlag) {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PATIENT_DAYS"));
    } else if (consumptionValueFlag) {
      if (this.consumptionConfigDetail[0].amountMeasured == "u") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_USED_DATA"));
      }
      else if (this.consumptionConfigDetail[0].amountMeasured == "p") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PURCHASED_DATA"));
      }
    } else if (formValue1) {
      this.submitConsumtion()
    } else {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.NO_CHANGES_TO_SAVE"));
    }
  }

  convertCommaToDot() {
    this.consumptionQuarterPeriodForm.value.items.forEach(item => {
      if (typeof item.consumptionValue === 'string') {
        item.consumptionValue = item.consumptionValue.replace(',', '.');
      }
    });
  }

  submitConsumtion() {
    var id = this.consumptionID;
    var value = this.consumptionQuarterPeriodForm.value;
    this.service.updateConsumptionPeriodById(id, value.items).subscribe((res: any) => {
      this.childData.emit({
        key: false,
        val: "save"
      })
      // this.layoutService.showSuccess(this.layoutService.translateText("CONSUMPTION.CONSUMPTION.SUCCESSFULLY_ADDED_DETAILS"));
      this.router.navigate(['/consumption/past']);

    })
  }
  cancelConsupmtionPeriod() {
    this.getConsumptionPeriodLis()
    this.viewConsumption = false;
    this.editconsumptionDisabled = false;
    this.childData.emit({
      key: false,
      val: "cancel"
    })
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  createItem(): UntypedFormGroup {
    return this.fb.group({
      consumptionID: this.consumptionID,
      consumptionValue: new UntypedFormControl({ value: '', disabled: true }),
      patientDays: new UntypedFormControl({ value: '0', disabled: true }),
      haiOccurrences: new UntypedFormControl({ value: '', disabled: true }),
      periodNumber: this.periodNumber,
      consumptionPeriodID: this.consumptionPeriodID
    })
  }

  getConsumptionPeriodLis() {
    this.service.getConsumptionPeriodById(this.consumptionID).subscribe((res: Array<ConsumptionPeriod> = []) => {
      this.consumptionPeriodDetail = res;
      for (let i = 0; i < this.consumptionPeriodDetail.length; i++) {
        this.items.at(i).patchValue({
          consumptionValue: this.consumptionPeriodDetail[i].consumptionValue,
          patientDays: this.consumptionPeriodDetail[i].patientDays,
          periodNumber: this.consumptionPeriodDetail[i].periodNumber,
          consumptionPeriodID: this.consumptionPeriodDetail[i].consumptionPeriodID,
          haiOccurrences: this.consumptionPeriodDetail[i].haiOccurrences || ''
        });
      }
    });
  }

  getConsumptionConfigByInstitutionIdList() {
    this.service.getSOPConsumptionByConsumptionId(this.consumptionID).subscribe((res: any) => {
      this.consumptionData = res;
      this.service.getConsumptionConfigByInstitutionId(this.layoutService.institutionID).subscribe((res: Array<any> = []) => {
        this.consumptionConfigDetail[0] = res;
        this.consumptionYearConfiguration = this.service.getConsumptionYearConfiguration(this.consumptionConfigDetail[0].consumptionConfigs, this.consumptionData[0].year)
        this.haiEnabled = this.consumptionConfigDetail[0].enableHAITracking;
      });
    });
  }


  amountMeasure() {
    if (this.consumptionYearConfiguration?.amountMeasured === 'u') {
      return this.layoutService.translateText('CONSUMPTION.USED.DISPLAY_TEXT');
    } else if (this.consumptionYearConfiguration?.amountMeasured === 'p') {
      return this.layoutService.translateText('CONSUMPTION.PURCHASED.DISPLAY_TEXT');
    }
  }

  unitMeasure() {
    if (this.consumptionYearConfiguration?.unitOfMeasure === 'l') {
      return this.layoutService.translateText(this.translationKeys.Dashboard.inLiters);
    } else if (this.consumptionYearConfiguration?.unitOfMeasure === 'm') {
      return this.layoutService.translateText('CONSUMPTION.AMOUNT.IN_MILLILITERS');
    }
  }

  getControls(frmGrp: UntypedFormGroup, key: string) {
    return (<UntypedFormArray>frmGrp.controls[key]).controls;
  }

  isLiters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'l';
  }

  isMilliliters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'm';
  }

}
